/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxDataTableComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxdatatable';

/**
 * Data Table
 */

export class NgcDataTableComponent extends ControlComponent {
     altRows: any;
     autoRowHeight: any;
     aggregatesHeight: any;
     autoShowLoadElement: any;
     columnsHeight: any;
     columns: any;
     columnGroups: any;
     columnsResize: any;
     columnsReorder: any;
     editable: any;
     editSettings: any;
     exportSettings: any;
     enableHover: any;
     enableBrowserSelection: any;
     filterable: any;
     filterHeight: any;
     filterMode: any;
     groups: any;
     groupsRenderer: any;
     initRowDetails: any;
     incrementalSearch: any;
     localization: any;
     pagerHeight: any;
     pageSize: any;
     pageSizeOptions: any;
     pageable: any;
     pagerPosition: any;
     pagerMode: any;
     pagerButtonsCount: any;
     pagerRenderer: any;
     ready: any;
     rowDetails: any;
     renderToolbar: any;
     renderStatusbar: any;
     rendering: any;
     rendered: any;
     rtl: any;
     source: any;
     sortable: any;
     showAggregates: any;
     showToolbar: any;
     showStatusbar: any;
     statusBarHeight: any;
     scrollBarSize: any;
     selectionMode: any;
     serverProcessing: any;
     showHeader: any;
     theme: any;
     toolbarHeight: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-datatable',
    template: `<jqxDataTable *ngIf="visible"
                [altRows] = "altRows"
                [autoRowHeight] = "autoRowHeight"
                [aggregatesHeight] = "aggregatesHeight"
                [autoShowLoadElement] = "autoShowLoadElement"
                [columnsHeight] = "columnsHeight"
                [columns] = "columns"
                [columnGroups] = "columnGroups"
                [columnsResize] = "columnsResize"
                [columnsReorder] = "columnsReorder"
                [disabled] = "disabled"
                [editable] = "editable"
                [editSettings] = "editSettings"
                [exportSettings] = "exportSettings"
                [enableHover] = "enableHover"
                [enableBrowserSelection] = "enableBrowserSelection"
                [filterable] = "filterable"
                [filterHeight] = "filterHeight"
                [filterMode] = "filterMode"
                [groups] = "groups"
                [groupsRenderer] = "groupsRenderer"
                [initRowDetails] = "initRowDetails"
                [incrementalSearch] = "incrementalSearch"
                [localization] = "localization"
                [pagerHeight] = "pagerHeight"
                [pageSize] = "pageSize"
                [pageSizeOptions] = "pageSizeOptions"
                [pageable] = "pageable"
                [pagerPosition] = "pagerPosition"
                [pagerMode] = "pagerMode"
                [pagerButtonsCount] = "pagerButtonsCount"
                [pagerRenderer] = "pagerRenderer"
                [ready] = "ready"
                [rowDetails] = "rowDetails"
                [renderToolbar] = "renderToolbar"
                [renderStatusbar] = "renderStatusbar"
                [rendering] = "rendering"
                [rendered] = "rendered"
                [rtl] = "rtl"
                [source] = "source"
                [sortable] = "sortable"
                [showAggregates] = "showAggregates"
                [showToolbar] = "showToolbar"
                [showStatusbar] = "showStatusbar"
                [statusBarHeight] = "statusBarHeight"
                [scrollBarSize] = "scrollBarSize"
                [selectionMode] = "selectionMode"
                [serverProcessing] = "serverProcessing"
                [showHeader] = "showHeader"
                [theme] = "theme"
                [toolbarHeight] = "toolbarHeight"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxDataTable>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'altRows': [{ type: Input, args: ['altRows', ] },],
'autoRowHeight': [{ type: Input, args: ['autoRowHeight', ] },],
'aggregatesHeight': [{ type: Input, args: ['aggregatesHeight', ] },],
'autoShowLoadElement': [{ type: Input, args: ['autoShowLoadElement', ] },],
'columnsHeight': [{ type: Input, args: ['columnsHeight', ] },],
'columns': [{ type: Input, args: ['columns', ] },],
'columnGroups': [{ type: Input, args: ['columnGroups', ] },],
'columnsResize': [{ type: Input, args: ['columnsResize', ] },],
'columnsReorder': [{ type: Input, args: ['columnsReorder', ] },],
'editable': [{ type: Input, args: ['editable', ] },],
'editSettings': [{ type: Input, args: ['editSettings', ] },],
'exportSettings': [{ type: Input, args: ['exportSettings', ] },],
'enableHover': [{ type: Input, args: ['enableHover', ] },],
'enableBrowserSelection': [{ type: Input, args: ['enableBrowserSelection', ] },],
'filterable': [{ type: Input, args: ['filterable', ] },],
'filterHeight': [{ type: Input, args: ['filterHeight', ] },],
'filterMode': [{ type: Input, args: ['filterMode', ] },],
'groups': [{ type: Input, args: ['groups', ] },],
'groupsRenderer': [{ type: Input, args: ['groupsRenderer', ] },],
'initRowDetails': [{ type: Input, args: ['initRowDetails', ] },],
'incrementalSearch': [{ type: Input, args: ['incrementalSearch', ] },],
'localization': [{ type: Input, args: ['localization', ] },],
'pagerHeight': [{ type: Input, args: ['pagerHeight', ] },],
'pageSize': [{ type: Input, args: ['pageSize', ] },],
'pageSizeOptions': [{ type: Input, args: ['pageSizeOptions', ] },],
'pageable': [{ type: Input, args: ['pageable', ] },],
'pagerPosition': [{ type: Input, args: ['pagerPosition', ] },],
'pagerMode': [{ type: Input, args: ['pagerMode', ] },],
'pagerButtonsCount': [{ type: Input, args: ['pagerButtonsCount', ] },],
'pagerRenderer': [{ type: Input, args: ['pagerRenderer', ] },],
'ready': [{ type: Input, args: ['ready', ] },],
'rowDetails': [{ type: Input, args: ['rowDetails', ] },],
'renderToolbar': [{ type: Input, args: ['renderToolbar', ] },],
'renderStatusbar': [{ type: Input, args: ['renderStatusbar', ] },],
'rendering': [{ type: Input, args: ['rendering', ] },],
'rendered': [{ type: Input, args: ['rendered', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'source': [{ type: Input, args: ['source', ] },],
'sortable': [{ type: Input, args: ['sortable', ] },],
'showAggregates': [{ type: Input, args: ['showAggregates', ] },],
'showToolbar': [{ type: Input, args: ['showToolbar', ] },],
'showStatusbar': [{ type: Input, args: ['showStatusbar', ] },],
'statusBarHeight': [{ type: Input, args: ['statusBarHeight', ] },],
'scrollBarSize': [{ type: Input, args: ['scrollBarSize', ] },],
'selectionMode': [{ type: Input, args: ['selectionMode', ] },],
'serverProcessing': [{ type: Input, args: ['serverProcessing', ] },],
'showHeader': [{ type: Input, args: ['showHeader', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'toolbarHeight': [{ type: Input, args: ['toolbarHeight', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Data Table Module
 */

export class NgcDataTableModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcDataTableComponent],
    declarations: [NgcDataTableComponent, jqxDataTableComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
